class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    // Invalidate any response for the previously selected variant, including
    // when the new option combination does not resolve to a variant.
    this.productInfoRequest = (this.productInfoRequest || 0) + 1;
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.getPreOrderVariantData();
    this.updatePickupAvailability();
    this.updateContent();
    this.showProductInfoError(false);

    if (!this.currentVariant) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      window.hederaVariantState.end(productForm, true);
      this.hideProductInfo();
      if (productForm) productForm.dataset.hdProductInfoPending = "true";
      document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      ).forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (!input) return;
        input.value = "";
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
      this.toggleAddButton(true, "", true);
      this.setUnavailable();

      // HEDERA — تركيبة خيارات غير موجودة: بث نفس حدث المزامنة المستخدم في
      // updateVariantInput()، بمعرّف فارغ وحالة unavailable، حتى لا يحتفظ
      // الشريط الثابت بمعرّف Variant سابق صالح يمكن إضافته إلى السلة بالخطأ.
      document.dispatchEvent(
        new CustomEvent("hedera:variant:changed", {
          detail: { id: null, sectionId: this.dataset.section, state: "unavailable" },
        })
      );
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.disablePurchaseUntilUpdated();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll(".product-form__input--dropdown")).map(
      (select, index) => {
        select.children[0].children[1].innerHTML = this.options[index];
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
  }

  updateContent() {
    let variant = this.currentVariant;
    let variandID = this.currentVariant?.id ?? null;
     let soldOurtProductURL = document.getElementById(`soldout__product_url--${this.dataset.section}`);

    // Back In Stock Notification
     if (variandID != null && !variant.available && soldOurtProductURL) {
		soldOurtProductURL.value = `${this.dataset.origin}${this.dataset.url}?variant=${this.currentVariant.id}`;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    // HEDERA — إشعار واحد يلتقطه شريط الشراء الثابت للمزامنة، بلا Listener مكرر.
    document.dispatchEvent(
      new CustomEvent("hedera:variant:changed", {
        detail: { id: this.currentVariant.id, sectionId: this.dataset.section },
      })
    );
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    const variant = this.currentVariant;
    const request = this.productInfoRequest;
    fetch(
      `${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => {
        if (!response.ok) throw new Error(`Product information: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        if (!this.isConnected || request !== this.productInfoRequest ||
            this.currentVariant?.id !== variant.id) return;
        let id = `price-${this.dataset.section}`,
          stockInventory = `inventory__stock--${this.dataset.section}`,
          deliveryPromise = `delivery-promise--${this.dataset.section}`,
          barcodeId = `barcode__${this.dataset.section}`,
          skuId = `sku__${this.dataset.section}`,
          notifyStock = `notify__me--available-${this.dataset.section}`;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        let destination = document.getElementById(id),
          stockInventoryDestination = document.getElementById(stockInventory),
          deliveryPromiseDestination = document.getElementById(deliveryPromise),
          barcodeDestination = document.getElementById(barcodeId),
          skuDestination = document.getElementById(skuId),
          notifyStockProduct = document.getElementById(notifyStock);

        let source = html.getElementById(id),
          stockInventorySource = html.getElementById(stockInventory),
          deliveryPromiseSource = html.getElementById(deliveryPromise),
          barcodeSource = html.getElementById(barcodeId),
          skuSource = html.getElementById(skuId),
          notifyStockProductSource = html.getElementById(notifyStock);

        // The price block is optional in the product section. A present price
        // destination still requires matching markup in the returned section.
        if (destination && !source) throw new Error("Product information is missing a price");
        if (!source && !stockInventorySource && !deliveryPromiseSource &&
            !barcodeSource && !skuSource && !notifyStockProductSource &&
            !html.getElementById(`product-form-${this.dataset.section}`))
          throw new Error("Product information is missing its section markup");

        if (destination) destination.innerHTML = source.innerHTML;
        if (stockInventorySource && stockInventoryDestination) {
          stockInventoryDestination.innerHTML = stockInventorySource.innerHTML;
          // HEDERA — مزامنة صنف الحاوية أيضًا (available / preorder / unavailable)
          stockInventoryDestination.className = stockInventorySource.className;
          stockInventoryDestination.hidden = stockInventorySource.hidden;
        }
        if (deliveryPromiseSource && deliveryPromiseDestination) {
          deliveryPromiseDestination.innerHTML = deliveryPromiseSource.innerHTML;
          deliveryPromiseDestination.className = deliveryPromiseSource.className;
          deliveryPromiseDestination.dataset.hdDeliveryState =
            deliveryPromiseSource.dataset.hdDeliveryState || "";
          deliveryPromiseDestination.hidden = deliveryPromiseSource.hidden;

          if (deliveryPromiseSource.hidden) {
            deliveryPromiseDestination.setAttribute("aria-hidden", "true");
          } else {
            deliveryPromiseDestination.removeAttribute("aria-hidden");
          }
        }
        if (barcodeSource && barcodeDestination)
          barcodeDestination.innerHTML = barcodeSource.innerHTML;
        if (skuSource && skuDestination)
          skuDestination.innerHTML = skuSource.innerHTML;
      
        if (notifyStockProductSource && notifyStockProduct) {
          notifyStockProduct.innerHTML = notifyStockProductSource.innerHTML;
          notifyStockProduct.className = notifyStockProductSource.className;
          notifyStockProduct.style.cssText = notifyStockProductSource.style.cssText;
          notifyStockProduct.hidden = notifyStockProductSource.hidden;
        }

        [[source, destination], [stockInventorySource, stockInventoryDestination],
          [barcodeSource, barcodeDestination], [skuSource, skuDestination],
          [notifyStockProductSource, notifyStockProduct],
          [deliveryPromiseSource, deliveryPromiseDestination]].forEach(([sourceElement, element]) => {
          if (!sourceElement || !element) return;
          element.style.visibility = "";
          element.removeAttribute("aria-busy");
        });

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("no-js-inline");
        this.toggleAddButton(
          !variant.available,
          window.variantStrings.soldOut
        );
        const form = document.getElementById(`product-form-${this.dataset.section}`);
        if (form) delete form.dataset.hdProductInfoPending;
        window.hederaVariantState.end(form);
        this.showProductInfoError(false);
        document.dispatchEvent(new CustomEvent("hedera:variant:changed", {
          detail: { id: variant.id, sectionId: this.dataset.section },
        }));
      })
      .catch((error) => {
        if (!this.isConnected || request !== this.productInfoRequest ||
            this.currentVariant?.id !== variant.id) return;
        console.error(error);
        window.hederaVariantState.end(document.getElementById(`product-form-${this.dataset.section}`), true);
        document.dispatchEvent(new CustomEvent("hedera:variant:changed", {
          detail: { id: null, sectionId: this.dataset.section, state: "unavailable" },
        }));
        this.showProductInfoError(window.variantStrings.updateError || window.cartStrings.error);
      });
  }

  showProductInfoError(message) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const formElement = productForm?.closest("product-form");
    if (typeof formElement?.handleErrorMessage === "function")
      formElement.handleErrorMessage(message);
  }

  disablePurchaseUntilUpdated() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const elements = ["price-", "inventory__stock--", "delivery-promise--", "barcode__", "sku__", "notify__me--available-"]
      .map(prefix => document.getElementById(`${prefix}${this.dataset.section}`));
    window.hederaVariantState.begin(productForm, elements);
    // The sticky form must not submit a variant while its visible details are stale.
    document.dispatchEvent(new CustomEvent("hedera:variant:changed", {
      detail: { id: null, sectionId: this.dataset.section, state: "pending" },
    }));
  }

  hideProductInfo() {
    ["price-", "inventory__stock--", "delivery-promise--", "barcode__",
      "sku__", "notify__me--available-"].forEach((prefix) => {
      const element = document.getElementById(`${prefix}${this.dataset.section}`);
      if (!element) return;
      element.style.visibility = "hidden";
      element.setAttribute("aria-busy", "true");
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    // HEDERA v1.3.1 — نفس الحالة النهائية المستخدمة أدناه لضبط زر أضف إلى
    // السلة (available/preorder/unavailable) تُعاد استخدامها حرفيًا لتحديد
    // ظهور Buy Now، بدل الاعتماد على disabled فقط (الطلب المسبق زر فعّال
    // لكن يجب أن يختفي Buy Now فيه أيضًا).
    let state = disable ? "unavailable" : "available";

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    // HEDERA — data-preorder يحمل حالة التتبع الصريحة من Liquid. لا نعتمد
    // على رقم الكمية وحده، لأن المنتج غير المتتبَّع قد يحمل رقماً سالباً.
    const productVarArray = this.PreorderVariantData;
    const variant = this.currentVariant;
    const variantData =
      productVarArray && variant ? productVarArray[variant.id] : null;

    if (variantData && variantData.tracked === true) {
      const inventoryQuantity = Number(variantData.qty);
      const inventoryPolicy = variantData.inventory_policy;

      if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
        addButton.removeAttribute("disabled");
        addButton.textContent = window.variantStrings.preorder;
        state = "preorder";
      } else if (inventoryQuantity <= 0) {
        addButton.setAttribute("disabled", true);
        addButton.textContent = window.variantStrings.soldOut;
        state = "unavailable";
      }
    }

    // HEDERA v1.3.1 — Buy Now يظهر فقط عند الحالة النهائية available؛ يختفي
    // فعليًا (غير قابل للنقر/الإرسال) عند preorder أو unavailable، بلا أي
    // منطق مخزون مستقل جديد ودون لمس مصدر الحالة الموحّد.
    this.syncPreorderProperty(productForm, state);
    this.toggleBuyNow(productForm, state);

    if (!modifyClass) return;
  }

  toggleBuyNow(productForm, state) {
    const buyNow = productForm.querySelector("[data-hd-buy-now]");
    if (!buyNow) return;
    buyNow.classList.toggle("hd-buy-now--disabled", state !== "available");
  }

  syncPreorderProperty(productForm, state) {
    if (typeof window.hederaSyncPreorderProperty !== "function") return;
    window.hederaSyncPreorderProperty(productForm, state);
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    this.syncPreorderProperty(button, "unavailable");
    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant]").textContent);
    return this.variantData;
  }
  getPreOrderVariantData() {
    this.PreorderVariantData =
      this.PreorderVariantData ||
      JSON.parse(this.querySelector("[data-preorder]").textContent);
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateOptionsParent() {
    this.fieldsets.map((fieldset, index) => {
      fieldset.children[0].children[1].innerHTML = this.options[index];
    });
  }
}
customElements.define("variant-radios", VariantRadios);
